import { StoreType, useActions } from 'utils/connect';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { consumer } from '@tock/coretypes';
import { useHistory, useParams } from 'react-router';
import { useMountEffect } from '@tock/hooks';
import { useSelector } from 'react-redux';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import EditBusinessCollectionDataConfigurationForm from 'components/consumer-widget-data-configs/business-collection-data-config/EditBusinessCollectionDataConfigurationForm';
import EditLuceneDataConfigForm from 'components/consumer-widget-data-configs/lucene-data-config/EditLuceneDataConfigForm';

interface MatchParams {
  id: string;
}

const getCollectionDataFormForType = (
  config: consumer.ICollectionDataConfiguration,
  onComplete: () => void
) => {
  const dataConfigType = (config as consumer.CollectionDataConfiguration).dataConfiguration;

  if (!dataConfigType) {
    return null;
  }

  switch (dataConfigType) {
    case 'collectionConfig':
      return (
        <EditBusinessCollectionDataConfigurationForm
          onCompleteOrCancel={onComplete}
          editDataConfig={config}
        />
      );
    case 'businessLuceneSearch':
    case 'experienceLuceneSearch':
      return (
        <EditLuceneDataConfigForm
          dataConfigType={
            dataConfigType === 'businessLuceneSearch' ? 'businessLucene' : 'experienceLucene'
          }
          editDataConfig={config}
          onCompleteOrCancel={onComplete}
        />
      );
    default:
      assertNever(dataConfigType);
  }
};

const CollectionDataConfigsEditRoute: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<MatchParams>();
  const history = useHistory();

  const collectionDataConfigId = Number(id);
  const { actions } = useActions();
  useMountEffect(() => {
    actions.consumerPage.fetchAllCollectionDataConfigurations('ALL');
  });

  const collectionDataConfigurations = useSelector(
    (state: StoreType) => state.consumerPage.collectionDataConfigurations || []
  );

  const collectionDataConfig = collectionDataConfigurations.find(
    (config) => config.id === collectionDataConfigId
  );

  if (!collectionDataConfig) {
    return null;
  }

  const form = getCollectionDataFormForType(collectionDataConfig, () => history.goBack());

  return (
    <div className="Content">
      <ClowncarHeaderV2
        heading={`Editing collection data config - ${collectionDataConfig?.name}`}
      />
      <div className="Main">
        <ClowncarBodyV2>{form}</ClowncarBodyV2>
      </div>
    </div>
  );
};

export default CollectionDataConfigsEditRoute;
